// src/services/api.js
// ALL backend calls go through here.
// credentials: "include" ensures httpOnly cookies are sent automatically.
// The frontend never sees or handles tokens directly.

const BASE = "https://api.pulselogistics.com.ng/api";
const request = async (method, path, body = null) => {
  const opts = {
    method,
    credentials: "include", // Send httpOnly cookies automatically
    headers: { "Content-Type": "application/json" },
  };
  if (body) opts.body = JSON.stringify(body);

  const res = await fetch(`${BASE}${path}`, opts);
  const data = await res.json();

  // If token expired, try to refresh once then retry
  if (res.status === 401 && data.code === "TOKEN_EXPIRED") {
    const refreshRes = await fetch(`${BASE}/auth/refresh`, {
      method: "POST",
      credentials: "include",
    });
    if (refreshRes.ok) {
      // Retry original request
      const retry = await fetch(`${BASE}${path}`, opts);
      return retry.json();
    } else {
      // Refresh failed — redirect to login
      window.location.href = "/login";
      return;
    }
  }

  return data;
};

// ── Auth ──────────────────────────────────────────────────────────────
export const login = (email, password) =>
  request("POST", "/auth/login", { email, password });

export const logout = () => request("POST", "/auth/logout");

export const getMe = () => request("GET", "/auth/me");

// ── Shipments ─────────────────────────────────────────────────────────
export const trackShipment = (awb) =>
  request("GET", `/shipments/track/${awb}`);

export const getAllShipments = (page = 1, status = "") =>
  request("GET", `/shipments?page=${page}&status=${status}`);

export const createShipment = (data) =>
  request("POST", "/shipments", data);

export const updateShipmentStatus = (awb, status, description, location) =>
  request("PATCH", `/shipments/${awb}/status`, { status, description, location });

export const assignRider = (awb, riderId) =>
  request("PATCH", `/shipments/${awb}/assign`, { riderId });

export const getRiderShipments = () =>
  request("GET", "/shipments/rider/assigned");

// ── Pickup Requests ───────────────────────────────────────────────────
export const submitPickupRequest = (data) =>
  request("POST", "/pickup-requests", data);

export const getPickupRequests = () =>
  request("GET", "/pickup-requests");

// ── Admin ─────────────────────────────────────────────────────────────
export const getDashboardStats = () =>
  request("GET", "/admin/stats");

export const getRiders = () =>
  request("GET", "/admin/riders");
export const getStaff = () =>
  request("GET", "/admin/staff");

export const createUser = (data) =>
  request("POST", "/admin/users", data);
export const convertPickupToShipment = (id, riderId, eta) =>
  request("POST", `/pickup-requests/${id}/convert`, { riderId, eta });